import type { CategoryArchiveProps } from "@/components/resources/data/archives"
import { CategoryArchive } from "./CategoryArchive"
import { ChangelogCategoryArchive } from "./ChangelogCategoryArchive"

/** A page of a /resources/[category] archive. The changelog is a timeline of whole posts. */
export const ResourceCategoryArchive = (props: CategoryArchiveProps) =>
  props.category === "changelog" ? (
    <ChangelogCategoryArchive {...props} />
  ) : (
    <CategoryArchive {...props} />
  )
